"use client";

import { AuthContext } from "@/components/providers/AuthContextProvider";
import { getLabel } from "@/data/labels";
import { useHandleClickOutside } from "@/hooks";
import { getLocaleFromPathname, getLocalePrefix } from "@/utils/getLocaleFromPath";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useContext, useRef } from "react";

interface UserDropdownProps {
  setUserDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function UserDropdown({ setUserDropdownOpen }: UserDropdownProps) {
  const drodownRef = useRef(null);
  useHandleClickOutside(drodownRef, () => setUserDropdownOpen(false));
  const context = useContext(AuthContext);
  const pathname = usePathname();
  const locale = getLocaleFromPathname(pathname) || "te-IN";
  const localePrefix = getLocalePrefix(pathname) || "/en-IN";
  const lang = (locale.split("-")[0] || "en") as "en" | "te";

  return (
    <div
      ref={drodownRef}
      className="absolute top-[32px] right-0 bg-white dark:bg-gray-900 shadow-md rounded min-w-[180px] border-t-4 border-t-[#FF0004] z-10 text-gray-900 dark:text-white"
    >
      <ul>
        <li>
          <Link
            href={`${localePrefix}/user/profile`}
            className="block px-4 py-2.5 transition-all hover:bg-gray-100 dark:hover:bg-gray-800 text-[15px] font-medium text-inherit"
            onClick={() => setUserDropdownOpen(false)}
            aria-label="Go to profile"
          >
            {getLabel(lang, "PROFILE")}
          </Link>
        </li>
        <li
          onClick={() => {
            context?.logout();
          }}
          className="block px-4 py-2.5 transition-all hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer text-[15px] font-medium text-inherit"
        >
          {getLabel(lang, "LOGOUT")}
        </li>
      </ul>
    </div>
  );
}
